import { DateTimePicker, DesktopDatePicker, LocalizationProvider } from '@mui/lab';
import { Alert, Autocomplete, Box, Breadcrumbs, Button, Card, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, Grid, IconButton, InputAdornment, InputLabel, Link, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import { Formik } from 'formik';
import moment from 'moment';
import React, { useEffect } from 'react'
import Swal from 'sweetalert2';
import api from "../../../../components/services/api";
import AddIcon from "@mui/icons-material/Add";
import withReactContent from "sweetalert2-react-content";
import { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import mime from "mime";
import { saveAs } from "file-saver";
import { makeStyles } from "@mui/styles";
import { SUM_FREETIME } from '../../components/sum';
import ClearIcon from "@mui/icons-material/Clear";

const useStyles = makeStyles({
    customOutline: {
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "red",
        },
    },
});
export default function BookingInformation({ setSaleOrderNo, setStatusSelect_data }) {
    const history = useHistory();
    const { id } = useParams()
    const classes = useStyles();
    const [loading, setLoading] = useState(false)
    const [loadingBD, setLoadingBD] = useState(false)
    const [dateetd, setEtd] = useState("");
    const [closing_date, setClosingdate] = useState("");
    const [diremark, setDiremark] = useState(false);
    const [remarklog, setremarkLog] = useState("");
    const [remarkType, setremarkType] = useState("");

    const [DetDemDisable, setDetDemDisable] = useState(false);
    const [ComDisable, setComDisable] = useState(false);
    const [com_caluateSelect, setCom_caluateSelect] = useState(false);

    /////////////////////////////////State_Data_Master////////////////////////////////////////
    const [bookingData, setBookingData] = useState()
    const [forwarderData, setForwarderData] = useState([])
    const [customerData, setCustomerData] = useState([])
    const [commodityData, setCommodityData] = useState([])
    const [quotationData, setQuotationData] = useState([])
    const [containerData, setContainerData] = useState([])
    const [packageData, setPackageData] = useState([])
    const [linersData, setLinersData] = useState([])
    const [freightForwarderData, setFreightForwarderData] = useState([])
    const [countryData, setCountryData] = useState([]);
    const [terminalData, setTerminalData] = useState([]);
    const [podTerminalData, setPodTerminalData] = useState([]);
    const [groupData, setGroupData] = useState([]);
    const [transshipmentData, setTransshipmentData] = useState([]);
    const [incotermData, setIncotermData] = useState([])
    const [termsData, setTermsData] = useState([])
    const [depotsData, setDepotsData] = useState([])
    const [factoryData, setFactoryData] = useState([])
    const [locationData, setLocationData] = useState([])

    ///////////////////////////////State_ID//////////////////////////////////////////////
    const [forwardingId, setForwardingId] = useState('')
    const [quotationId, setQuotationID] = useState('')
    const [customerID, setCustomerID] = useState('')

    const handleCloseremark = () => {
        setDiremark(false)
        setremarkLog('')
        setremarkType('')
    }

    //////////////////////////////////// fetch Master ///////////////////////////////////////

    useEffect(() => {

        const getBookingData = async () => {
            const res = await api.get(`api/saleorder/detail/bookinginfo/${id}`)
            const data = await res.data
            if (res.meta.status === true) {
                setBookingData(data)
                setSaleOrderNo(data.SaleOrderNo)
                setStatusSelect_data(data.SaleOrderStatus)
                setCustomerID(data.CustomerId)
                // setCustomerID(data);

            }
        }
        getBookingData()

    }, [id])

    useEffect(() => {
        const getQuotation = async () => {
            if (customerID !== null && customerID !== undefined) {
                const id = {
                    id: customerID,
                };
                try {

                    const res = await api.post("api/master/referquotation", id);
                    const data = await res.data
                    if (res.meta.status === true) {
                        setQuotationData(data.data)

                    }
                } catch (e) {
                    console.log(e);
                }
            }
        };
        getQuotation()
    }, [customerID])
    const getMasterCountry = async () => {
        const res = await api.get(`api/master/country`)
        const data = await res.data
        if (res.meta.status === true) {
            setCountryData(data.data)
        }
    }
    const getMasterGroup = async () => {
        const res = await api.get(`api/master/group`)
        const data = await res.data
        if (res.meta.status === true) {
            setGroupData(data.data)
        }
    }

    const getCustomerList = async () => {
        const params = {
            cusType: 2,
        };
        try {
            const res = await api.post("api/customer/list", params);
            const data = await res.data
            if (res.meta.status === true) {
                setCustomerData(data.filter((x) => x?.Status === true));
            }
        } catch (e) {
            console.log(e);
        }
    };
    const getForwarderData = async () => {
        const params = {
            cusType: 1,
        };
        try {
            const res = await api.post("api/customer/list", params);
            const data = await res.data
            if (res.meta.status === true) {
                setForwarderData(data.filter((x) => x?.Status === true));
            }
        } catch (e) {
            console.log(e);
        }
    };


    const getFreightForwarder = async () => {
        try {
            const res = await api.get("api/master/freightforwarder");
            const data = await res.data
            if (res.meta.status === true) {
                setFreightForwarderData(data)
            }
        } catch (e) {
            console.log(e);
        }
    };
    const getMasterPackage = async () => {
        try {
            const res = await api.get("api/master/package");
            const data = await res.data
            if (res.meta.status === true) {
                setPackageData(data.data)
            }
        } catch (e) {
            console.log(e);
        }
    };
    const getFactoryList = async () => {
        try {
            const res = await api.get("api/factory/list");
            const data = await res.data
            if (res.meta.status === true) {
                setFactoryData(data.filter((x) => x?.Status === true))
            }
        } catch (e) {
            console.log(e);
        }
    };
    const getTransshipment = async () => {
        try {
            const res = await api.get("api/transshipment/list");
            const data = await res.data
            if (res.meta.status === true) {
                setTransshipmentData(data.filter((x) => x?.Status === true));
            }
        } catch (e) {
            console.log(e);
        }
    };
    const getCommodity = async () => {
        try {
            const res = await api.get("api/commodity/list");
            const data = await res.data
            if (res.meta.status === true) {
                setCommodityData(data.filter((x) => x?.Status === true));
            }
        } catch (e) {
            console.log(e);
        }
    };
    const getContaier = async () => {
        try {
            const res = await api.get("api/container/list");
            const data = await res.data
            if (res.meta.status === true) {
                setContainerData(data.filter((x) => x?.Status === true));
            }
        } catch (e) {
            console.log(e);
        }
    };
    const getLiners = async () => {
        try {
            const res = await api.get("api/liners/list");
            const data = await res.data
            if (res.meta.status === true) {
                setLinersData(data.filter((x) => x?.Status === true));
            }
        } catch (e) {
            console.log(e);
        }
    };
    const getDepots = async () => {
        try {
            const res = await api.get("api/depots/list");
            const data = await res.data
            if (res.meta.status === true) {
                setDepotsData(data.filter((x) => x?.Status === true));
            }
        } catch (e) {
            console.log(e);
        }
    };
    const getTerminal = async () => {
        try {
            const res = await api.get("api/location/list");
            const data = await res.data
            if (res.meta.status === true) {
                setTerminalData(data.filter((x) => x?.Status === true));
            }
        } catch (e) {
            console.log(e);
        }
    };
    const getTerms = async () => {
        try {
            const res = await api.get("api/terms/list");
            const data = await res.data
            if (res.meta.status === true) {
                setTermsData(data.filter((x) => x?.Status === true));
            }
        } catch (e) {
            console.log(e);
        }
    };
    const getIncoTerms = async () => {
        try {
            const res = await api.get("api/inco/list");
            const data = await res.data
            if (res.meta.status === true) {
                setIncotermData(data.filter((x) => x?.Status === true));
            }
        } catch (e) {
            console.log(e);
        }
    };
    const getPodTerminal = async () => {
        try {
            const res = await api.get("api/location/list");
            const data = await res.data
            if (res.meta.status === true) {
                setPodTerminalData(data.filter((x) => x?.Status === true));
            }
        } catch (e) {
            console.log(e);
        }
    };
    const getLocation = async () => {
        try {
            const res = await api.get("api/location/list");
            const data = await res.data
            if (res.meta.status === true) {
                setLocationData(data.filter((x) => x?.Status === true));
            }
        } catch (e) {
            console.log(e);
        }
    };
    useEffect(() => {
        getMasterCountry()
        getMasterGroup()
        getCustomerList()
        getForwarderData()
        getFreightForwarder()
        getMasterPackage()
        getFactoryList()
        getTransshipment()
        getCommodity()
        getContaier()
        getLiners()
        getDepots()
        getTerminal()
        getTerms()
        getIncoTerms()
        getPodTerminal()
        getLocation()
    }, [])

    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                {bookingData ?
                    <Formik
                        enableReinitialize
                        initialValues={{
                            forwarding: bookingData?.ForwardingName,
                            forwardingId: bookingData?.ForwardingId,
                            customer_name: bookingData?.CustomerName,
                            customer_id: bookingData?.CustomerId,
                            quotation_no: bookingData?.QuotationId,
                            shipper_ref_no: bookingData?.ShipperRefNo,
                            shipper_si_no: null,
                            shipper_invoice_no: bookingData?.ShipperInvoiceNo,
                            detail_quotation: '',
                            volume_container: bookingData?.ContainerTypeId,
                            volume_quantity: bookingData?.Quantity,
                            commodity: bookingData?.CommodityId ? bookingData?.CommodityId : '',
                            packaging: bookingData?.PackageId,
                            booking_no: bookingData?.BookingNo,
                            liners: linersData?.length > 0 ? linersData?.find((x) => x?.LinersId === bookingData?.LinersId) : null,
                            freight_forwarder: freightForwarderData.length > 0 ? freightForwarderData?.find((x) => x?.FreightId === bookingData?.FreightForwarderId) : null,
                            etd_pol: bookingData?.ETDPOLDate,
                            etd_time: bookingData?.ETDPOLTime,
                            closing_date: bookingData?.ClosingDate,
                            closing_time: bookingData?.ClosingTime,
                            // conuntrylinerId: bookingData?.,
                            pol_conuntry: countryData?.length > 0 ? countryData?.find((x) => x?.CountryId === bookingData?.POLCountryId) : null,
                            pol_terminal: locationData?.length > 0 ? locationData?.find((x) => x?.LocationId === bookingData?.POLLocationId) : null,
                            pod_conuntry: countryData?.length > 0 ? countryData?.find((x) => x?.CountryId === bookingData?.PODCountryId) : null,
                            pod_terminal: locationData?.length > 0 ? locationData?.find((x) => x?.LocationId === bookingData?.PODLocationId) : null,
                            eta_pod: bookingData?.ETAPODDate,
                            eta_time: bookingData?.ETAPODTime,
                            det: bookingData?.DET,
                            dem: bookingData?.DEM,
                            com: bookingData?.COM,
                            c_det: bookingData?.COMDET,
                            c_dem: bookingData?.COMDEM,
                            CountingType: bookingData?.CountingType,
                            choice_com_calculate: '',

                            first_pickup: bookingData?.FirstPickupDate,
                            actual_pickup: bookingData?.ActualPickupDate,

                            return_date: null,
                            actual_return_date: null,
                            first_Laden_Date: bookingData?.FirstLadenDate,
                            actual_Laden_Date: bookingData?.ActualLadenDate,
                            cut_off_VGM: bookingData?.CutOffVGMDate,
                            cut_off_VGM_time: bookingData?.CutOffVGMTime,

                            cut_off_SI: bookingData?.CutOffSIDate,
                            cut_off_SI_time: bookingData?.CutOffSITime,

                            first_vissel: bookingData?.FeederVessel,
                            first_vissel_transshipment: bookingData?.FeederTransshipmentId,
                            second_vissel: bookingData?.MotherVessel,
                            second_vissel_transshipment: bookingData?.MotherTransshipmentId,
                            third_vissel: bookingData?.ThirdVessel,
                            third_vissel_transshipment: bookingData?.ThirdTransshipmentId,
                            inco_terms: bookingData?.IncotermsId,
                            freight_terms: bookingData?.FreightTermsId,
                            InboundGateOutId: bookingData?.InboundGateOutId,
                            OutboundGateOutId: bookingData?.OutboundGateOutId,
                            // RemarkLogStatus: ''
                            // container_require_select: '',
                            // grade: "",
                            // apply_layer_plastic_sheet: '',
                            // depots: null,
                            transport_InBound: bookingData?.InboundTransportGroupId,
                            // InBoundGateOut: '',
                            // container_gender_Inbound: '',
                            transport_OutBound: bookingData?.OutboundTransportGroupId,
                            // OutBoundGateOut: '',
                            // container_gender_OutBound: '',
                            // voyIn: '',
                            // ETD_Gate_Out_Inbound: null,
                            // ETA_Gate_In_Inbound: null,
                            // first_Laden_Date: null,
                            // actual_Laden_Date: null,
                            // voyOut: '',
                            // ETD_Gate_Out_OutBound: null,
                            // ETA_Gate_In_OutBound: null,
                            // phyto_cert: '',
                            // fumigation: '',
                            // phyto_cert_remark: '',
                            // fumigation_remark: ''
                        }}
                        onSubmit={(values, { setSubmitting }) => {

                            const body = {

                                SaleOrderId: id,
                                // ForwardingId: values.forwarding,
                                // CustomerId: values.customer_id,
                                // ForwardingId: values.forwarding,
                                // CustomerId: values.customer_name,
                                CommodityId: values.commodity,
                                QuotationId: values.quotation_no,
                                ShipperRefNo: values.shipper_ref_no,
                                ShipperInvoiceNo: values.shipper_invoice_no,
                                ContainerTypeId: values.volume_container,
                                Quantity: values.volume_quantity,
                                PackageId: values.packaging,
                                BookingNo: values.booking_no,
                                // LinersId: values.liners,
                                // FreightForwarderId: values.freight_forwarder,
                                LinersId: values.liners?.LinersId || null,
                                FreightForwarderId: values.freight_forwarder?.FreightId || null,
                                ETDPOLDate: values.etd_pol,
                                ETDPOLTime: values.etd_time,
                                ClosingDate: values.closing_date,
                                ClosingTime: values.closing_time,
                                POLCountryId: values.pol_conuntry?.CountryId || null,
                                POLLocationId: values.pol_terminal?.LocationId || null,
                                PODCountryId: values.pod_conuntry?.CountryId || null,
                                PODLocationId: values.pod_terminal?.LocationId || null,
                                ETAPODDate: values.eta_pod,
                                ETAPODTime: values.eta_time,
                                DET: values.det,
                                DEM: values.dem,
                                COM: values.com,
                                CountingType: values.CountingType,
                                COMDET: values.c_det,
                                COMDEM: values.c_dem,
                                CutOffVGMDate: values.cut_off_VGM,
                                CutOffVGMTime: values.cut_off_SI_time,
                                CutOffSIDate: values.cut_off_SI,
                                CutOffSITime: values.cut_off_SI_time,
                                FeederVessel: values.first_vissel,
                                FeederTransshipmentId: values.first_vissel_transshipment,
                                MotherVessel: values.second_vissel,
                                MotherTransshipmentId: values.second_vissel_transshipment,
                                ThirdVessel: values.third_vissel,
                                ThirdTransshipmentId: values.third_vissel_transshipment,
                                FreightTermsId: values.freight_terms,
                                IncotermsId: values.inco_terms,
                                FirstPickupDate: values.first_pickup || null,
                                ActualPickupDate: values.actual_pickup,
                                FirstLadenDate: values.first_Laden_Date || null,
                                ActualLadenDate: values.actual_Laden_Date || null,

                                InboundGateOutId: values.InboundGateOutId,
                                OutboundGateOutId: values.OutboundGateOutId,
                                InboundTransportGroupId: values.transport_InBound,
                                OutboundTransportGroupId: values.transport_OutBound,
                                RemarkLogStatus: remarklog,
                                RemarkType: remarkType
                            }
                            const postData = async () => {
                                const res = await api.post("api/saleorder/update/bookinginfo", body)
                                const data = await res.data
                                if (res.meta.status === true) {
                                    const MySwal = withReactContent(Swal);

                                    MySwal.fire({
                                        icon: "success",
                                        didOpen: () => {
                                            MySwal.clickConfirm();
                                        },
                                    }).then(() => {
                                        return MySwal.fire(
                                            "สำเร็จ!",
                                            "เเก้ไข Sale Order สำเร็จ !",
                                            "success"
                                        ).then((result) => {
                                            if (result.isConfirmed) {
                                                // history.push("/CustomerSupport/SaleOrder");
                                            }
                                        });

                                    });
                                } else {
                                    console.log(data.message)
                                }
                            }
                            setTimeout(() => {
                                postData()
                                // console.log(body)
                                setSubmitting(false);

                            }, 400);

                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue,
                            /* and other goodies */
                        }) => (
                            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
                                <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                                    Forwarding
                                </h6>
                                <Grid container>
                                    <Grid item xs={12} md={12}>
                                        <div>
                                            <TextField
                                                name="forwarding"
                                                label="Forwarding"
                                                variant="outlined"
                                                disabled
                                                placeholder="Forwarding"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                InputLabelProps={{ shrink: true }}
                                                value={values.forwarding}
                                                // classes={{
                                                //   root:
                                                //     customer_id === ""
                                                //       ? classes.customOutline
                                                //       : classes,
                                                // }}
                                                fullWidth
                                            />
                                            {/* <Autocomplete
                                                disablePortal
                                                id="combo-box-demo"
                                                options={forwarderData}
                                                disabled
                                                getOptionLabel={(option) => option?.CustomerName}
                                                value={values.forwarding}
                                                onChange={(x, y) => {
                                                    if (y !== null) {
                                                        setForwardingId(y?.CustomerId);
                                                        setFieldValue("forwarding", y?.CustomerId)
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        name="forwarding"
                                                        label="Forwarding"
                                                        variant="outlined"
                                                        placeholder="Forwarding"
                                                        {...params}
                                                        fullWidth
                                                    />
                                                )}
                                            /> */}
                                        </div>
                                        <h6
                                            style={{ marginTop: "10px" }}
                                            className="textcolordarkblue"
                                        >
                                            CUSTOMER
                                        </h6>
                                        <div>
                                            {/* <Autocomplete
                                                disablePortal
                                                id="combo-box-demo"
                                                options={customerData}
                                                getOptionLabel={(option) => option?.CustomerName}
                                                onChange={(x, y) => {
                                                    getQuotation(x, y)
                                                    setFieldValue("customer_name", y?.CustomerId)

                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        name="customer_name"
                                                        label="CUSTOMER NAME"
                                                        variant="outlined"
                                                        placeholder="Customer Name"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        InputLabelProps={{ shrink: true }}
                                                        value={values.customer_name}
                                                        // classes={{
                                                        //   root:
                                                        //     customer_id === ""
                                                        //       ? classes.customOutline
                                                        //       : classes,
                                                        // }}
                                                        {...params}
                                                        fullWidth
                                                    />
                                                )}
                                            /> */}
                                            <TextField
                                                name="customer_name"
                                                label="CUSTOMER NAME"
                                                variant="outlined"
                                                disabled
                                                placeholder="Customer Name"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                InputLabelProps={{ shrink: true }}
                                                value={values.customer_name}
                                                // classes={{
                                                //   root:
                                                //     customer_id === ""
                                                //       ? classes.customOutline
                                                //       : classes,
                                                // }}
                                                fullWidth
                                            />
                                        </div>
                                        <div style={{ display: "flex", marginTop: 10 }}>
                                            <FormControl
                                                sx={{ width: "50%" }}
                                                classes={{
                                                    root:
                                                        !values.quotation_no
                                                            ? classes.customOutline
                                                            : null,
                                                }}
                                                required
                                            >
                                                <InputLabel>
                                                    Refer Quotation no.
                                                </InputLabel>
                                                <Select
                                                    name="quotation_no"
                                                    value={values.quotation_no ? values.quotation_no : ""}
                                                    onChange={(e) => {
                                                        setFieldValue("quotation_no", e.target.value);
                                                        setQuotationID(e.target.value);
                                                        const _quotationId = e.target.value;
                                                        const quatation = quotationData.find(
                                                            (x) => x.QuotationId === _quotationId
                                                        );

                                                        // const _quotationId = e.target.value;
                                                        // const quatation = quotationData.find(
                                                        //   (x) => x.QuotationId === _quotationId
                                                        // );

                                                        const countryPol = locationData.find(
                                                            (x) => x.LocationId === quatation?.LocationFrom
                                                        );
                                                        const OutBoundGateOut = locationData.find(
                                                            (x) => x.LocationId === quatation?.LocationTo
                                                        );
                                                        // setFieldValue('pol_conuntry', countryPol?.CountryId)
                                                        // setFieldValue('pol_terminals', quatation?.LocationFrom)
                                                        setFieldValue('commodity', quatation?.CommodityId)
                                                        setFieldValue('InBoundGateOut', OutBoundGateOut)
                                                        setFieldValue('transport_InBound', quatation?.GroupTo)
                                                        setFieldValue('OutBoundGateOut', countryPol)
                                                        setFieldValue('InboundGateOutId', OutBoundGateOut?.LocationId)
                                                        setFieldValue('OutBoundGateOutId', countryPol?.LocationId)
                                                        setFieldValue('transport_OutBound', quatation?.GroupFrom)
                                                        // console.log(quatation)
                                                        // console.log(countryPol)
                                                        // console.log(countryPol, OutBoundGateOut)

                                                        setFieldValue(
                                                            "detail_quotation",
                                                            quatation?.ServiceInfo
                                                        );

                                                        //   console.log(quatation);
                                                    }}
                                                    onBlur={handleBlur}
                                                    label="Refer Quotation no."
                                                >
                                                    <MenuItem value="" disabled>
                                                        <em>กรุณาค้นหา CustomerName </em>
                                                    </MenuItem>
                                                    {quotationData?.map((option, index) => {
                                                        return (
                                                            <MenuItem key={index} value={option?.QuotationId}>
                                                                {option?.QuotationNo}
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Select>
                                            </FormControl>
                                            <TextField
                                                name="shipper_ref_no"
                                                label="SHIPPER REF NO."
                                                variant="outlined"
                                                placeholder="SHIPPER REF NO."
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                style={{ width: "50%", marginLeft: 5 }}
                                                InputLabelProps={{ shrink: true }}
                                                value={values.shipper_ref_no}
                                            // classes={{
                                            //   root:
                                            //     values.shipper_ref_no === ""
                                            //       ? classes.customOutline
                                            //       : classes,
                                            // }}
                                            />

                                            {/* {errors.shipper_ref_no &&
                        touched.shipper_ref_no &&
                        errors.shipper_ref_no} */}
                                        </div>
                                        <div style={{ display: "flex", marginTop: 10 }}>
                                            <TextField
                                                name="shipper_si_no"
                                                label="SHIPPER SI NO."
                                                variant="outlined"
                                                placeholder="SHIPPER SI NO."
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                style={{ width: "50%", marginRight: 5 }}
                                                InputLabelProps={{ shrink: true }}
                                                value={values.shipper_si_no}
                                            />
                                            {/* {errors.shipper_si_no &&
                        touched.shipper_si_no &&
                        errors.shipper_si_no} */}
                                            <TextField
                                                name="shipper_invoice_no"
                                                label="SHIPPER INVOICE. NO."
                                                variant="outlined"
                                                placeholder="SHIPPER INVOICE. NO."
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                style={{ width: "50%", marginRight: 5 }}
                                                InputLabelProps={{ shrink: true }}
                                                value={values.shipper_invoice_no}
                                            />
                                            {/* {errors.shipper_invoice_no &&
                        touched.shipper_invoice_no &&
                        errors.shipper_invoice_no} */}
                                        </div>
                                        <div style={{ display: "flex", marginTop: 10 }}>
                                            <TextField
                                                label="รายละเอียดตู้ Quotation"
                                                value={values.detail_quotation}
                                                name="detail_quotation"
                                                InputLabelProps={{ shrink: true }}
                                                disabled
                                                multiline
                                                rows={2}
                                                fullWidth
                                            />

                                            {/* <Button
                      type="button"
                      variant="outlined"
                      size="small"
                      style={{
                        color: "#007BFF",
                        borderColor: "#007BFF",

                        marginRight: "10px",
                        marginLeft: "10px",
                        textTransform: "none",
                      }}
                    >
                      แก้ไข
                    </Button> */}

                                            {/* <Button
                        type="button"
                        variant="contained"
                        style={{
                          background: "#007BFF",
                          borderColor: "#007BFF",
                          marginRight: "10px",
                          marginLeft: "10px",
                          textTransform: "none",
                        }}
                      >
                        {isSubmitting && <CircularProgress size={22} />}
                        {!isSubmitting && "ยืนยัน"}
                      </Button> */}
                                        </div>
                                        <h6
                                            style={{ marginTop: "10px" }}
                                            className="textcolordarkblue"
                                        >
                                            VOLUME
                                        </h6>
                                        <div
                                            style={{
                                                display: "flex",
                                                marginTop: 10,
                                            }}
                                        >
                                            <FormControl
                                                sx={{ width: "50%" }}
                                                classes={{
                                                    root:
                                                        !values.volume_container
                                                            ? classes.customOutline
                                                            : null,
                                                }}
                                                required
                                            >
                                                <InputLabel>
                                                    Container
                                                </InputLabel>
                                                <Select
                                                    name="volume_container"
                                                    label="Container "
                                                    value={values.volume_container}
                                                    InputLabelProps={{ shrink: true }}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    style={{ borderColor: "red" }}
                                                >
                                                    <MenuItem value="" disabled>
                                                        <em>เลือก Container</em>
                                                    </MenuItem>
                                                    {containerData?.map((option, index) => {
                                                        return (
                                                            <MenuItem
                                                                key={index}
                                                                value={option?.ContainerTypeId}
                                                            >
                                                                {option?.ContainerTypeName}
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Select>
                                            </FormControl>
                                            <TextField
                                                name="volume_quantity"
                                                label="Quantity"
                                                variant="outlined"
                                                placeholder="Quantity"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                style={{ width: "50%", marginRight: 5, marginLeft: 5 }}
                                                InputLabelProps={{ shrink: true }}
                                                value={values.volume_quantity}
                                            // classes={{
                                            //   root:
                                            //     values.volume_quantity === ""
                                            //       ? classes.customOutline
                                            //       : classes,
                                            // }}
                                            />
                                            {/* {errors.volume_quantity &&
                        touched.volume_quantity &&
                        errors.volume_quantity} */}
                                        </div>
                                        <div style={{ display: "flex", marginTop: 10 }}>
                                            <FormControl
                                                sx={{ width: "50%", mr: "5px" }}
                                                classes={{
                                                    root:
                                                        !values.commodity
                                                            ? classes.customOutline
                                                            : null,
                                                }}
                                                required
                                            >
                                                <InputLabel>
                                                    COMMODITY
                                                </InputLabel>
                                                <Select
                                                    name="commodity"
                                                    label="COMMODITY"
                                                    disabled
                                                    value={values.commodity}
                                                    InputLabelProps={{ shrink: true }}
                                                    onChange={(e) => {
                                                        setFieldValue("commodity", e.target.value);
                                                        // setQuotation_id(e.target.value);
                                                        // const _quotationId = e.target.value;
                                                        // const quatation = quotation_fetch_data.find(
                                                        //   (x) => x.CommodityId === _quotationId
                                                        // );
                                                    }}
                                                >
                                                    <MenuItem value="" disabled>
                                                        <em>เลือก COMMODITY </em>
                                                    </MenuItem>

                                                    {commodityData?.map((option, index) => {
                                                        return (
                                                            <MenuItem key={index} value={option?.CommodityId}>
                                                                {option?.CommodityName}
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Select>
                                            </FormControl>

                                            <FormControl sx={{ width: "25%", mr: "5px" }}>
                                                <InputLabel>PACKAGING</InputLabel>
                                                <Select
                                                    name="packaging"
                                                    label="PACKAGING"
                                                    value={values.packaging}
                                                    InputLabelProps={{ shrink: true }}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                >
                                                    <MenuItem value="" disabled>
                                                        <em>เลือก PACKAGING </em>
                                                    </MenuItem>

                                                    {packageData.map((option, index) => {
                                                        return (
                                                            <MenuItem key={index} value={option?.PackageId}>
                                                                {option?.PackageName}
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <h4
                                            style={{ marginTop: "10px" }}
                                            className="textcolordarkblue"
                                        >
                                            Booking Information
                                        </h4>
                                        <div style={{ marginTop: 10 }}>
                                            <TextField
                                                name="booking_no"
                                                label="BOOKING NO."
                                                variant="outlined"
                                                placeholder="BOOKING NO."
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                InputLabelProps={{ shrink: true }}
                                                value={values.booking_no}
                                                fullWidth
                                            />
                                            {/* {errors.booking_no &&
                    touched.booking_no &&
                    errors.booking_no} */}
                                        </div>
                                        <h6
                                            style={{ marginTop: "10px" }}
                                            className="textcolordarkblue"
                                        >
                                            Shipping Line
                                        </h6>
                                        <div style={{ display: "flex", marginTop: 10 }}>
                                            {/* <FormControl sx={{ width: "50%" }}>
                                                <InputLabel>LINERS</InputLabel>
                                                <Select
                                                    name="liners"
                                                    label="LINERS"
                                                    value={values.liners}
                                                    InputLabelProps={{ shrink: true }}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                // disabled={values.freight_forwarder !== ""}
                                                >
                                                    <MenuItem value="" disabled>
                                                        <em>เลือก Liners </em>
                                                    </MenuItem>
                                                    {linersData.map((option, index) => {
                                                        return (
                                                            <MenuItem
                                                                key={index}
                                                                value={option?.LinersId}
                                                            >
                                                                {option?.LinersName}
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Select>
                                            </FormControl>
                                            <FormControl sx={{ width: "50%", ml: "5px" }}>
                                                <InputLabel>FREIGHT FORWARDER</InputLabel>
                                                <Select
                                                    name="freight_forwarder"
                                                    label="FREIGHT FORWARDER"
                                                    value={values.freight_forwarder}
                                                    InputLabelProps={{ shrink: true }}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                // disabled={values.liners !== ""}
                                                >
                                                    <MenuItem value="" disabled>
                                                        <em>เลือก FREIGHT FORWARDER </em>
                                                    </MenuItem>
                                                    {freightForwarderData.map(
                                                        (option, index) => {
                                                            return (
                                                                <MenuItem
                                                                    key={index}
                                                                    value={option?.FreightId}
                                                                >
                                                                    {option?.FreightForwarderName}
                                                                </MenuItem>
                                                            );
                                                        }
                                                    )}
                                                </Select>
                                            </FormControl> */}

                                            <Autocomplete
                                                name="liners"
                                                options={linersData}
                                                getOptionLabel={(option) => option?.LinersName}
                                                // classes={{
                                                //   root:
                                                //     !formik.values.serviceRoute.locationTo
                                                //       ? classes.customOutline
                                                //       : null,
                                                // }}

                                                onChange={(x, y) => {
                                                    setFieldValue("liners", y);

                                                }}
                                                id="flat-demo"

                                                value={values.liners || null}
                                                sx={{ width: "50%", }}
                                                renderInput={(params) => (
                                                    <TextField  {...params} label="LINERS" />
                                                )}
                                            />

                                            <Autocomplete
                                                name="freight_forwarder"
                                                options={freightForwarderData}
                                                getOptionLabel={(option) => option?.FreightForwarderName}
                                                // classes={{
                                                //   root:
                                                //     !formik.values.serviceRoute.locationTo
                                                //       ? classes.customOutline
                                                //       : null,
                                                // }}

                                                onChange={(x, y) => {
                                                    setFieldValue("freight_forwarder", y);

                                                }}
                                                id="flat-demo"

                                                value={values.freight_forwarder || null}
                                                sx={{ width: "50%", ml: "5px" }}
                                                renderInput={(params) => (
                                                    <TextField  {...params} label="FREIGHT FORWARDER" />
                                                )}
                                            />
                                        </div>
                                        <div style={{ display: "flex", marginTop: 10, flexWrap: 'wrap' }}>

                                            <div style={{ width: '100%', flexBasis: '50%' }}>
                                                <h6
                                                    style={{ marginTop: "10px" }}
                                                    className="textcolordarkblue"
                                                >
                                                    ETD POL
                                                </h6>
                                                <div style={{ display: 'flex' }}>
                                                    <DesktopDatePicker
                                                        label="ETD POL"
                                                        inputFormat="dd/MM/yyyy"
                                                        name="etd_pol"
                                                        // disablePast
                                                        value={values?.etd_pol}

                                                        onChange={(e) => {
                                                            const nformat = moment(e).format(
                                                                "yyyy-MM-DD"
                                                            );

                                                            setEtd(nformat);
                                                            // console.log(nformat)

                                                            setFieldValue("etd_pol", nformat);

                                                            if (values.com) {
                                                                const pickup_Em = SUM_FREETIME(values.CountingType + '_PE', nformat, values.closing_date, values.first_pickup, values.actual_Laden_Date, values.det, values.dem, values.com)
                                                                const laden_Date = SUM_FREETIME(values.CountingType + '_RL', nformat, values.closing_date, pickup_Em, values.actual_pickup, values.det, values.dem, values.com)

                                                                if (pickup_Em) setFieldValue("first_pickup", pickup_Em)
                                                                if (laden_Date) setFieldValue("first_Laden_Date", laden_Date)

                                                            } else {
                                                                const pickup_Date = SUM_FREETIME(values.CountingType + '_DET', nformat, values.closing_date, values.first_pickup, values.actual_Laden_Date, values.det, values.dem, values.com)
                                                                const laden_Date = SUM_FREETIME(values.CountingType + '_DEM', nformat, values.closing_date, values.first_pickup, values.actual_pickup, values.det, values.dem, values.com)
                                                                if (pickup_Date) setFieldValue("first_pickup", pickup_Date)
                                                                if (laden_Date) setFieldValue("first_Laden_Date", laden_Date)

                                                            }
                                                            // if (values.dem != "" && values.det != "") {
                                                            //     let cal_days =
                                                            //         -(parseInt(values.det) + parseInt(values.dem)) +
                                                            //         2;
                                                            //     let caldet = +parseInt(values.det);
                                                            //     let cal_dayss = +parseInt(values.dem);
                                                            //     let date_now = +new Date(nformat);
                                                            //     if (values.det != "" && values.dem != "") {
                                                            //         setFieldValue(
                                                            //             "first_pickup",
                                                            //             moment(
                                                            //                 new Date(
                                                            //                     date_now + cal_days * 24 * 60 * 60 * 1000
                                                            //                 )
                                                            //             ).format("YYYY-MM-DD")
                                                            //         );

                                                            //         // setTest(
                                                            //         //     moment(
                                                            //         //         new Date(
                                                            //         //             date_now +
                                                            //         //             (cal_days + cal_dayss) *
                                                            //         //             24 *
                                                            //         //             60 *
                                                            //         //             60 *
                                                            //         //             1000
                                                            //         //         )
                                                            //         //     ).format("DD-MM-YYYY")
                                                            //         // );

                                                            //         // let date_1 = +new Date(testa);
                                                            //         //     setdate1st(moment(
                                                            //         //       new Date(
                                                            //         //         date_1 + (cal_days + caldet) * 24 * 60 * 60 * 1000
                                                            //         //       )
                                                            //         //     ).format("DD-MM-YYYY"));
                                                            //     }
                                                            // }

                                                            // if (
                                                            //     values.com != "" &&
                                                            //     values.det == "" &&
                                                            //     values.dem == "" &&
                                                            //     values.choice_com_calculate == "1"
                                                            // ) {
                                                            //     let date_now = +new Date(nformat);
                                                            //     let com_value = -values.com + 1;
                                                            //     setFieldValue(
                                                            //         "first_pickup",
                                                            //         moment(
                                                            //             new Date(
                                                            //                 date_now + com_value * 24 * 60 * 60 * 1000
                                                            //             )
                                                            //         ).format("YYYY-MM-DD")
                                                            //     );
                                                            // }
                                                        }}
                                                        renderInput={(params) => <TextField style={{ width: '50%' }} {...params} classes={{
                                                            root:
                                                                !values.eta_pod
                                                                    ? classes.customOutline
                                                                    : null,
                                                        }}
                                                            required />}
                                                    />
                                                    <TextField
                                                        name="etd_time"
                                                        label="ETD TIME"
                                                        variant="outlined"
                                                        placeholder="ETD TIME"
                                                        type="time"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        style={{ width: "50%", marginLeft: 5 }}
                                                        InputLabelProps={{ shrink: true }}
                                                        value={values.etd_time}
                                                    />
                                                    {/* {errors.etd_time &&
                        touched.etd_time &&
                        errors.etd_time} */}

                                                </div>

                                            </div>
                                            <div style={{ width: "100%", flexBasis: '50%' }}>
                                                <h6
                                                    style={{ marginTop: "10px" }}
                                                    className="textcolordarkblue"
                                                >
                                                    Closing
                                                </h6>
                                                <div style={{ display: 'flex' }}>

                                                    <DesktopDatePicker
                                                        inputFormat="dd/MM/yyyy"
                                                        name="closing_date"
                                                        label="CLOSING DATE"

                                                        maxDate={new Date(dateetd)}
                                                        value={values.closing_date}
                                                        onChange={(e) => {
                                                            const nformat = moment(e).format(
                                                                "YYYY-MM-DD"
                                                            );

                                                            const mformat = moment(e,).format(
                                                                "YYYY-MM-DD"
                                                            );

                                                            setFieldValue("closing_date", nformat);

                                                            if (values.com) {
                                                                const pickup_Date = SUM_FREETIME(values.CountingType + '_PE', values.etd_pol, nformat, values.first_pickup, values.actual_Laden_Date, values.det, values.dem, values.com)
                                                                if (pickup_Date) setFieldValue("first_pickup", pickup_Date)
                                                            } else {
                                                                const pickup_Date = SUM_FREETIME(values.CountingType + '_DET', values.etd_pol, nformat, values.first_pickup, values.actual_Laden_Date, values.det, values.dem, values.com)
                                                                if (pickup_Date) setFieldValue("first_pickup", pickup_Date)
                                                            }
                                                            // setClosingdate(mformat);
                                                            // if (
                                                            //     values.com != "" &&
                                                            //     values.det == "" &&
                                                            //     values.dem == "" &&
                                                            //     values.choice_com_calculate == "2"
                                                            // ) {
                                                            //     let date_now = +new Date(nformat);

                                                            //     setFieldValue(
                                                            //         "first_pickup",
                                                            //         moment(
                                                            //             new Date(
                                                            //                 date_now + values.com * 24 * 60 * 60 * 1000
                                                            //             )
                                                            //         ).format("YYYY-MM-DD")
                                                            //     );
                                                            // }
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                style={{
                                                                    width: "50%",
                                                                    marginRight: 5,
                                                                    marginLeft: 5,
                                                                    // border:
                                                                    //     values.closing_date >= values.etd_pol && "#EE4B2B 2px solid",
                                                                }}
                                                                classes={{
                                                                    root:
                                                                        !values.closing_date || values.closing_date >= values.eta_pod
                                                                            ? classes.customOutline
                                                                            : null,
                                                                }}
                                                                required
                                                                {...params}
                                                            />
                                                        )}
                                                    />
                                                    <TextField
                                                        name="closing_time"
                                                        label="CLOSING TIME"
                                                        variant="outlined"
                                                        placeholder="CLOSING TIME"
                                                        type="time"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        style={{ width: "50%", marginRight: 5 }}
                                                        InputLabelProps={{ shrink: true }}
                                                        value={values.closing_time}
                                                    />
                                                    {/* {errors.closing_time &&
                        touched.closing_time &&
                        errors.closing_time} */}
                                                </div>
                                            </div>


                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <div style={{ width: "100%" }}>
                                                <h6
                                                    style={{ marginTop: "10px" }}
                                                    className="textcolordarkblue"
                                                >
                                                    Port of Loading
                                                </h6>
                                                <div style={{ display: 'flex' }}>
                                                    <Autocomplete
                                                        name="Country"
                                                        options={countryData}
                                                        getOptionLabel={(option) => option?.CountryName}

                                                        onChange={(x, y) => {
                                                            setFieldValue("pol_conuntry", y);
                                                            setFieldValue("pol_terminal", null);
                                                        }}
                                                        id="flat-demo"
                                                        value={values.pol_conuntry}
                                                        sx={{ width: "50%", mr: "5px" }}
                                                        renderInput={(params) => (
                                                            <TextField  {...params} label="Country" />
                                                        )}
                                                    />
                                                    <Autocomplete
                                                        name="pol_terminal"
                                                        options={terminalData?.filter((x) => x.CountryId === values.pol_conuntry?.CountryId)}
                                                        getOptionLabel={(option) => option?.LocationName}

                                                        onChange={(x, y) => {
                                                            setFieldValue("pol_terminal", y);

                                                        }}
                                                        id="flat-demo"

                                                        value={values.pol_terminal}
                                                        sx={{ width: "50%", mr: "5px" }}
                                                        renderInput={(params) => (
                                                            <TextField  {...params} label="Location" />
                                                        )}
                                                    />
                                                </div>

                                            </div>
                                        </div>

                                        <Divider sx={{ margin: '20px 0' }} />

                                        <div style={{ display: 'flex' }}>
                                            <div style={{ width: "100%" }}>
                                                <h6
                                                    // style={{ marginTop: "10px" }}
                                                    className="textcolordarkblue"
                                                >
                                                    Port of Discharge
                                                </h6>
                                                <div style={{ display: 'flex' }}>
                                                    <Autocomplete
                                                        name="Country"
                                                        options={countryData}
                                                        getOptionLabel={(option) => option?.CountryName}
                                                        // classes={{
                                                        //   root:
                                                        //     !formik.values.serviceRoute.locationTo
                                                        //       ? classes.customOutline
                                                        //       : null,
                                                        // }}

                                                        onChange={(x, y) => {
                                                            setFieldValue("pod_conuntry", y);
                                                            setFieldValue("pod_terminal", null);
                                                        }}
                                                        id="flat-demo"
                                                        // disabled={
                                                        //   values.liners ? true : false
                                                        // }
                                                        value={values.pod_conuntry}
                                                        sx={{ width: "50%", mr: "5px" }}
                                                        renderInput={(params) => (
                                                            <TextField  {...params} label="Country" />
                                                        )}
                                                    />
                                                    <Autocomplete
                                                        name="pod_terminal"
                                                        options={terminalData?.filter((x) => x.CountryId === values.pod_conuntry?.CountryId)}
                                                        getOptionLabel={(option) => option?.LocationName}
                                                        // classes={{
                                                        //   root:
                                                        //     !formik.values.serviceRoute.locationTo
                                                        //       ? classes.customOutline
                                                        //       : null,
                                                        // }}

                                                        onChange={(x, y) => {
                                                            setFieldValue("pod_terminal", y);

                                                        }}
                                                        id="flat-demo"
                                                        // disabled={
                                                        //   values.liners ? true : false
                                                        // }
                                                        value={values.pod_terminal}
                                                        sx={{ width: "50%", mr: "5px" }}
                                                        renderInput={(params) => (
                                                            <TextField  {...params} label="Location" />
                                                        )}
                                                    />

                                                </div>

                                            </div>

                                        </div>
                                        <div style={{ display: "flex", marginTop: 10, flexWrap: 'wrap' }}>
                                            <div style={{ width: '100%', flexBasis: '50%' }}>
                                                <h6
                                                    style={{ marginTop: "10px" }}
                                                    className="textcolordarkblue"
                                                >
                                                    ETA POD
                                                </h6>
                                                <div style={{ display: 'flex' }}>
                                                    <DesktopDatePicker
                                                        inputFormat="dd/MM/yyyy"
                                                        name="eta_pod"
                                                        label="ETA POD"
                                                        value={values.eta_pod}
                                                        // disablePast
                                                        sx={{
                                                            color: "red",
                                                        }}
                                                        onChange={(e) => {
                                                            const nformat = moment(e).format(
                                                                "YYYY-MM-DD"
                                                            );
                                                            // console.log(nformat);

                                                            setFieldValue("eta_pod", nformat);
                                                        }}
                                                        renderInput={(params) => (
                                                            <>
                                                                <TextField
                                                                    error
                                                                    sx={{
                                                                        width: "100%",
                                                                        // "& .MuiInputBase-input": {
                                                                        //   color:
                                                                        //     laden_etdDate !== "Invalid date"
                                                                        //       ? values.eta_pod > laden_etdDate
                                                                        //         ? "red"
                                                                        //         : "#000"
                                                                        //       : spDate !== "Invalid date"
                                                                        //         ? values.eta_pod > spDate
                                                                        //           ? "red"
                                                                        //           : "#000"
                                                                        //         : datemt !== "Invalid date"
                                                                        //           ? values.eta_pod > datemt
                                                                        //             ? "red"
                                                                        //             : "#000"
                                                                        //           : moment(values.eta_pod).format(
                                                                        //             "YYYY-MM-DD"
                                                                        //           ) > values.actual_return_date
                                                                        //             ? "red"
                                                                        //             : "#000",
                                                                        // },
                                                                    }}
                                                                    {...params}
                                                                />
                                                            </>
                                                        )}
                                                    />
                                                    {/* {errors.eta_pod &&
                        touched.eta_pod &&
                        errors.eta_pod} */}
                                                    <TextField
                                                        name="eta_time"
                                                        label="ETA TIME"
                                                        variant="outlined"
                                                        placeholder="ETA TIME"
                                                        type="time"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        style={{ width: "50%", marginLeft: 5 }}
                                                        InputLabelProps={{ shrink: true }}
                                                        value={values.eta_time}
                                                    />
                                                    {/* {errors.etd_time &&
                        touched.etd_time &&
                        errors.etd_time} */}

                                                </div>

                                            </div>



                                        </div>
                                        <div>
                                            <h6
                                                style={{ marginTop: "10px" }}
                                                className="textcolordarkblue"
                                            >
                                                FREE TIME
                                            </h6>
                                            <div style={{ display: "flex", marginTop: 10 }}>
                                                <TextField
                                                    name="det"
                                                    label="Detention"
                                                    type="number"
                                                    variant="outlined"
                                                    placeholder="Detention"
                                                    classes={{
                                                        root:
                                                            !values.det
                                                                ? classes.customOutline
                                                                : null,
                                                    }}
                                                    required
                                                    onChange={(e) => {
                                                        setFieldValue("det", e.target.value);
                                                        const pickup_Date = SUM_FREETIME(values.CountingType + '_DET', values.etd_pol, values.closing_date, values.first_pickup, values.actual_Laden_Date, e.target.value, values.dem, values.com)
                                                        if (pickup_Date) setFieldValue("first_pickup", pickup_Date)

                                                        // setDetValue(e.target.value);
                                                        // let cal_days =
                                                        //     -(parseInt(e.target.value) + parseInt(values.dem)) +
                                                        //     2;
                                                        // let cal_dayss = +parseInt(values.dem);
                                                        // let cal_det = +parseInt(e.target.value);
                                                        // let date_now = +new Date(values?.etd_pol);
                                                        // if (
                                                        //     e.target.value != "" &&
                                                        //     values.dem != "" &&
                                                        //     values.etd_pol != ""
                                                        // ) {
                                                        //     setFieldValue(
                                                        //         "first_pickup",
                                                        //         moment(
                                                        //             new Date(
                                                        //                 date_now + cal_days * 24 * 60 * 60 * 1000
                                                        //             )
                                                        //         ).format("YYYY-MM-DD")
                                                        //     );

                                                        //     setFieldValue(
                                                        //         "first_Laden_Date",
                                                        //         moment(
                                                        //             new Date(
                                                        //                 date_now +
                                                        //                 cal_days * 24 * 60 * 60 * 1000 +
                                                        //                 (cal_det - 1) * 24 * 60 * 60 * 1000
                                                        //             )
                                                        //         ).format("YYYY-MM-DD")
                                                        //     );


                                                        //     // setTest(
                                                        //     //   moment(
                                                        //     //     new Date(
                                                        //     //       date_now +
                                                        //     //       (cal_days + cal_dayss) * 24 * 60 * 60 * 1000
                                                        //     //     )
                                                        //     //   ).format("DD-MM-YYYY")
                                                        //     // );
                                                        // }
                                                        // if (e.target.value == "") {
                                                        //     setFieldValue("first_pickup", "");
                                                        // }
                                                        // e.target.value.length >= 1 || values.dem != ""
                                                        //     ? setComDisable(true)
                                                        //     : setComDisable(false);
                                                    }}
                                                    onBlur={handleBlur}
                                                    style={{ width: "50%", marginRight: 5 }}
                                                    InputLabelProps={{ shrink: true }}
                                                    disabled={values.com}
                                                    value={values.det}
                                                />
                                                {/* {errors.det && touched.det && errors.det} */}
                                                <TextField
                                                    name="dem"
                                                    label="Demurrage"
                                                    type="number"
                                                    variant="outlined"
                                                    placeholder="Demurrage"
                                                    classes={{
                                                        root:
                                                            !values.dem
                                                                ? classes.customOutline
                                                                : null,
                                                    }}
                                                    required
                                                    onChange={(e) => {
                                                        setFieldValue("dem", e.target.value);
                                                        const laden_Date = SUM_FREETIME(values.CountingType + '_DEM', values.etd_pol, values.closing_date, values.first_pickup, values.actual_pickup, values.det, e.target.value, values.com)
                                                        if (laden_Date) setFieldValue("first_Laden_Date", laden_Date)

                                                        // let cal_days =
                                                        //     -(parseInt(values.det) + parseInt(e.target.value)) +
                                                        //     2;
                                                        // let cal_dayss = +parseInt(values.dem);
                                                        // let cal_det = +parseInt(values.det);
                                                        // let date_now = +new Date(values?.etd_pol);
                                                        // if (
                                                        //     values.det != "" &&
                                                        //     e.target.value != "" &&
                                                        //     values.etd_pol != ""
                                                        // ) {
                                                        //     setFieldValue(
                                                        //         "first_pickup",
                                                        //         moment(
                                                        //             new Date(
                                                        //                 date_now + cal_days * 24 * 60 * 60 * 1000
                                                        //             )
                                                        //         ).format("YYYY-MM-DD")
                                                        //     );

                                                        //     setFieldValue(
                                                        //         "first_Laden_Date",
                                                        //         moment(
                                                        //             new Date(
                                                        //                 date_now +
                                                        //                 cal_days * 24 * 60 * 60 * 1000 +
                                                        //                 (cal_det - 1) * 24 * 60 * 60 * 1000
                                                        //             )
                                                        //         ).format("YYYY-MM-DD")
                                                        //     );

                                                        //     // setTest(
                                                        //     //   moment(
                                                        //     //     new Date(
                                                        //     //       (date_now + cal_days + cal_dayss) *
                                                        //     //         24 *
                                                        //     //         60 *
                                                        //     //         60 *
                                                        //     //         1000
                                                        //     //     )
                                                        //     //   ).format("DD-MM-YYYY")
                                                        //     // );
                                                        // }
                                                        // if (e.target.value == "") {
                                                        //     setFieldValue("first_pickup", "");
                                                        // }

                                                        // e.target.value || values.det
                                                        //     ? setComDisable(true)
                                                        //     : setComDisable(false);
                                                    }}
                                                    onBlur={handleBlur}
                                                    style={{ width: "50%", marginRight: 5 }}
                                                    InputLabelProps={{ shrink: true }}
                                                    disabled={values.com}
                                                    value={values.dem}
                                                />
                                                {/* {errors.dem && touched.dem && errors.dem} */}

                                                <TextField
                                                    name="com"
                                                    label="Combined"
                                                    type="number"
                                                    variant="outlined"
                                                    placeholder="COM"
                                                    classes={{
                                                        root:
                                                            !values.com
                                                                ? classes.customOutline
                                                                : null,
                                                    }}
                                                    required
                                                    onChange={(e) => {
                                                        setFieldValue("com", e.target.value);
                                                        if (e.target.value == "") {
                                                            setCom_caluateSelect(false);
                                                            setFieldValue("first_pickup", "");
                                                            setFieldValue("choice_com_calculate", "");
                                                        } else {
                                                            const pickup_Em = SUM_FREETIME(values.CountingType + '_PE', values.etd_pol, values.closing_date, values.first_pickup, values.actual_Laden_Date, values.det, values.dem, e.target.value)
                                                            const laden_Date = SUM_FREETIME(values.CountingType + '_RL', values.etd_pol, values.closing_date, pickup_Em, values.actual_pickup, values.det, values.dem, e.target.value)

                                                            if (pickup_Em) setFieldValue("first_pickup", pickup_Em)
                                                            if (laden_Date) setFieldValue("first_Laden_Date", laden_Date)
                                                        }
                                                        // setCom_caluateSelect(true);
                                                        // if (e.target.value == "") {
                                                        //     setCom_caluateSelect(false);
                                                        //     setFieldValue("first_pickup", "");
                                                        //     setFieldValue("choice_com_calculate", "");
                                                        // }
                                                        // e.target.value.length >= 1
                                                        //     ? setDetDemDisable(true)
                                                        //     : setDetDemDisable(false);
                                                    }}
                                                    onBlur={handleBlur}
                                                    style={{ width: "50%", marginRight: 5 }}
                                                    InputLabelProps={{ shrink: true }}
                                                    value={values.com}
                                                    disabled={values.dem || values.det}
                                                />
                                                {/* {errors.com && touched.com && errors.com} */}
                                                {/* {com_caluateSelect ? (
                                                    <>
                                                        <TextField
                                                            name="c_det"
                                                            label="DET"
                                                            type="number"
                                                            error={
                                                                parseInt(values.c_det) +
                                                                    parseInt(values.c_dem) <=
                                                                    values.com
                                                                    ? false
                                                                    : true
                                                            }
                                                            variant="outlined"
                                                            placeholder="DET"
                                                            onChange={(e) => {
                                                                setFieldValue("c_det", e.target.value);

                                                                // setDetValue(e.target.value);
                                                                let cal_days =
                                                                    -(
                                                                        parseInt(e.target.value) +
                                                                        parseInt(values.c_dem)
                                                                    ) + 2;
                                                                let cal_dayss = +parseInt(values.c_dem);
                                                                let cal_det = +parseInt(e.target.value);

                                                                let date_now = +new Date(values.etd_pol);
                                                                if (
                                                                    e.target.value != "" &&
                                                                    values.c_dem != "" &&
                                                                    values.etd_pol != ""
                                                                ) {
                                                                    setFieldValue(
                                                                        "first_pickup",
                                                                        moment(
                                                                            new Date(
                                                                                date_now +
                                                                                cal_days * 24 * 60 * 60 * 1000
                                                                            )
                                                                        ).format("YYYY-MM-DD")
                                                                    );

                                                                    setFieldValue(
                                                                        "first_Laden_Date",
                                                                        moment(
                                                                            new Date(
                                                                                date_now +
                                                                                cal_days * 24 * 60 * 60 * 1000 +
                                                                                (cal_det - 1) *
                                                                                24 *
                                                                                60 *
                                                                                60 *
                                                                                1000
                                                                            )
                                                                        ).format("YYYY-MM-DD")
                                                                    );
                                                                }
                                                                if (e.target.value == "") {
                                                                    setFieldValue("first_pickup", "");
                                                                }
                                                                e.target.value.length >= 1 || values.dem != ""
                                                                    ? setComDisable(true)
                                                                    : setComDisable(false);
                                                            }}
                                                            onBlur={handleBlur}
                                                            style={{ width: "50%", marginRight: 5 }}
                                                            InputLabelProps={{ shrink: true }}
                                                            value={values.c_det}
                                                        />
                                                        <TextField
                                                            name="c_dem"
                                                            label="DEM"
                                                            error={
                                                                parseInt(values.c_det) +
                                                                    parseInt(values.c_dem) <=
                                                                    values.com
                                                                    ? false
                                                                    : true
                                                            }
                                                            type="number"
                                                            variant="outlined"
                                                            placeholder="DEM"
                                                            onChange={(e) => {
                                                                setFieldValue("c_dem", e.target.value);
                                                                let cal_days =
                                                                    -(
                                                                        parseInt(values.c_det) +
                                                                        parseInt(e.target.value)
                                                                    ) + 2;
                                                                let cal_dayss = +parseInt(values.c_dem);
                                                                let cal_det = +parseInt(values.c_det);
                                                                let date_now = +new Date(values.etd_pol);
                                                                if (
                                                                    values.c_det != "" &&
                                                                    e.target.value != "" &&
                                                                    values.etd_pol != "" &&
                                                                    parseInt(values.c_det) +
                                                                    parseInt(e.target.value) <=
                                                                    values.com
                                                                ) {
                                                                    setFieldValue(
                                                                        "first_pickup",
                                                                        moment(
                                                                            new Date(
                                                                                date_now +
                                                                                cal_days * 24 * 60 * 60 * 1000
                                                                            )
                                                                        ).format("YYYY-MM-DD")
                                                                    );
                                                                    setFieldValue(
                                                                        "first_Laden_Date",
                                                                        moment(
                                                                            new Date(
                                                                                date_now +
                                                                                cal_days * 24 * 60 * 60 * 1000 +
                                                                                (cal_det - 1) *
                                                                                24 *
                                                                                60 *
                                                                                60 *
                                                                                1000
                                                                            )
                                                                        ).format("YYYY-MM-DD")
                                                                    );
                                                                }
                                                                if (e.target.value == "") {
                                                                    setFieldValue("first_pickup", "");
                                                                }
                                                            }}
                                                            onBlur={handleBlur}
                                                            style={{ width: "50%", marginRight: 5 }}
                                                            InputLabelProps={{ shrink: true }}
                                                            value={values.c_dem}
                                                        />
                                                    </>
                                                ) : null} */}
                                                <FormControl sx={{ width: "50%" }} >
                                                    <InputLabel>Counting</InputLabel>
                                                    <Select
                                                        name="CountingType"
                                                        label="Counting"
                                                        value={values.CountingType}
                                                        InputLabelProps={{ shrink: true }}
                                                        onChange={(e) => {
                                                            setFieldValue("CountingType", e.target.value);
                                                            console.log(e.target.value);
                                                            if (values.com) {
                                                                const pickup_Em = SUM_FREETIME(e.target.value + '_PE', values.etd_pol, values.closing_date, values.first_pickup, values.actual_Laden_Date, values.det, values.dem, values.com)
                                                                const laden_Date = SUM_FREETIME(e.target.value + '_RL', values.etd_pol, values.closing_date, pickup_Em, values.actual_pickup, values.det, values.dem, values.com)

                                                                if (pickup_Em) setFieldValue("first_pickup", pickup_Em)
                                                                if (laden_Date) setFieldValue("first_Laden_Date", laden_Date)
                                                            } else {
                                                                const pickup_Date = SUM_FREETIME(e.target.value + '_DET', values.etd_pol, values.closing_date, values.first_pickup, values.actual_Laden_Date, values.det, values.dem, values.com)
                                                                const laden_Date = SUM_FREETIME(e.target.value + '_DEM', values.etd_pol, values.closing_date, values.first_pickup, values.actual_pickup, values.det, values.dem, values.com)
                                                                if (pickup_Date) setFieldValue("first_pickup", pickup_Date)
                                                                if (laden_Date) setFieldValue("first_Laden_Date", laden_Date)

                                                            }
                                                        }}
                                                        onBlur={handleBlur}
                                                    >
                                                        <MenuItem value="Return Laden" >
                                                            Return Laden
                                                        </MenuItem>
                                                        <MenuItem value="Closing" >
                                                            Closing
                                                        </MenuItem>
                                                        <MenuItem value="ETD POL" >
                                                            ETD POL
                                                        </MenuItem>

                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", marginTop: 10, flexWrap: 'wrap' }}>
                                            <div style={{ width: '100%', flexBasis: '50%' }}>
                                                <h6
                                                    style={{ marginTop: "10px" }}
                                                    className="textcolordarkblue"
                                                >
                                                    Cut off VGM
                                                </h6>
                                                <div style={{ display: 'flex' }}>
                                                    <DesktopDatePicker
                                                        inputFormat="dd/MM/yyyy"
                                                        name="cut_off_VGM"
                                                        label="Data"
                                                        value={values.cut_off_VGM}
                                                        // disablePast

                                                        onChange={(e) => {
                                                            const nformat = moment(e).format(
                                                                "YYYY-MM-DD"
                                                            );
                                                            // console.log(nformat);

                                                            setFieldValue("cut_off_VGM", nformat);
                                                        }}
                                                        renderInput={(params) => (
                                                            <>
                                                                <TextField
                                                                    error
                                                                    sx={{
                                                                        width: "100%",

                                                                    }}
                                                                    {...params}
                                                                />
                                                            </>
                                                        )}
                                                    />
                                                    {/* {errors.eta_pod &&
                        touched.eta_pod &&
                        errors.eta_pod} */}
                                                    <TextField
                                                        name="cut_off_VGM_time"
                                                        label="TIME"
                                                        variant="outlined"
                                                        placeholder="TIME"
                                                        type="time"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        style={{ width: "50%", marginLeft: 5 }}
                                                        InputLabelProps={{ shrink: true }}
                                                        value={values.cut_off_VGM_time}
                                                    />
                                                    {/* {errors.etd_time &&
                                                        touched.etd_time &&
                                                        errors.etd_time} */}

                                                </div>
                                            </div>
                                            <div style={{ width: '100%', flexBasis: '50%' }}>
                                                <h6
                                                    style={{ marginTop: "10px" }}
                                                    className="textcolordarkblue"
                                                >
                                                    Cut off SI
                                                </h6>
                                                <div style={{ display: 'flex', marginLeft: 5 }}>
                                                    <DesktopDatePicker
                                                        inputFormat="dd/MM/yyyy"
                                                        name="cut_off_SI"
                                                        label="Date"
                                                        value={values.cut_off_SI}
                                                        // disablePast

                                                        onChange={(e) => {
                                                            const nformat = moment(e).format(
                                                                "YYYY-MM-DD"
                                                            );
                                                            // console.log(nformat);

                                                            setFieldValue("cut_off_SI", nformat);
                                                        }}
                                                        renderInput={(params) => (
                                                            <>
                                                                <TextField
                                                                    error
                                                                    sx={{
                                                                        width: "100%",

                                                                    }}
                                                                    {...params}
                                                                />
                                                            </>
                                                        )}
                                                    />
                                                    {/* {errors.eta_pod &&
                        touched.eta_pod &&
                        errors.eta_pod} */}
                                                    <TextField
                                                        name="cut_off_SI_time"
                                                        label="TIME"
                                                        variant="outlined"
                                                        placeholder="TIME"
                                                        type="time"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        style={{ width: "50%", marginLeft: 5 }}
                                                        InputLabelProps={{ shrink: true }}
                                                        value={values.cut_off_SI_time}
                                                    />
                                                    {/* {errors.etd_time &&
                        touched.etd_time &&
                        errors.etd_time} */}

                                                </div>
                                            </div>
                                        </div>

                                        <Divider sx={{ margin: '20px 0' }} />

                                        <h6
                                            // style={{ marginTop: "10px" }}
                                            className="textcolordarkblue"
                                        >
                                            Intended Vessel
                                        </h6>
                                        <div style={{ display: "flex", marginTop: 10 }}>
                                            <TextField
                                                name="first_vissel"
                                                label="Feeder Vessel"
                                                variant="outlined"
                                                placeholder="Feeder Vessel"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                style={{ width: "50%", marginRight: 5 }}
                                                InputLabelProps={{ shrink: true }}
                                                value={values.first_vissel}
                                            />
                                            {/* {errors.email && touched.email && errors.email} */}
                                            <FormControl sx={{ width: "50%" }}>
                                                <InputLabel>TRANSHIPMENT</InputLabel>
                                                <Select
                                                    name="first_vissel_transshipment"
                                                    label="TRANSHIPMENT"
                                                    value={values.first_vissel_transshipment}
                                                    InputLabelProps={{ shrink: true }}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    endAdornment={
                                                        values.first_vissel_transshipment && (
                                                          <InputAdornment position="end" sx={{marginRight:'30px'}}>
                                                            <IconButton
                                                              onClick={() =>
                                                                setFieldValue(
                                                                  "first_vissel_transshipment",
                                                                  ""
                                                                )
                                                              }
                                                              edge="end"
                                                            >
                                                              <ClearIcon />
                                                            </IconButton>
                                                          </InputAdornment>
                                                        )
                                                      }
                                                >
                                                    <MenuItem value="" disabled>
                                                        <em>เลือก TRANSSHIPMENT </em>
                                                    </MenuItem>
                                                    {transshipmentData.map(
                                                        (option, index) => {
                                                            return (
                                                                <MenuItem
                                                                    key={index}
                                                                    value={option?.TransshipmentId}
                                                                >
                                                                    {option?.TransshipmentName}
                                                                </MenuItem>
                                                            );
                                                        }
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div style={{ display: "flex", marginTop: 10 }}>
                                            <TextField
                                                name="second_vissel"
                                                label="Mother Vessel"
                                                variant="outlined"
                                                placeholder="Mother Vessel"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                style={{ width: "50%", marginRight: 5 }}
                                                InputLabelProps={{ shrink: true }}
                                                value={values.second_vissel}
                                            />
                                            {/* {errors.email && touched.email && errors.email} */}
                                            <FormControl sx={{ width: "50%" }}>
                                                <InputLabel>TRANSHIPMENT</InputLabel>
                                                <Select
                                                    name="second_vissel_transshipment"
                                                    label="TRANSHIPMENT"
                                                    value={values.second_vissel_transshipment}
                                                    InputLabelProps={{ shrink: true }}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    endAdornment={
                                                        values.second_vissel_transshipment && (
                                                          <InputAdornment position="end" sx={{marginRight:'30px'}}>
                                                            <IconButton
                                                              onClick={() =>
                                                                setFieldValue(
                                                                  "second_vissel_transshipment",
                                                                  ""
                                                                )
                                                              }
                                                              edge="end"
                                                            >
                                                              <ClearIcon />
                                                            </IconButton>
                                                          </InputAdornment>
                                                        )
                                                      }
                                                >
                                                    <MenuItem value="" disabled>
                                                        <em>เลือก TRANSSHIPMENT </em>
                                                    </MenuItem>
                                                    {transshipmentData.map(
                                                        (option, index) => {
                                                            return (
                                                                <MenuItem
                                                                    key={index}
                                                                    value={option?.TransshipmentId}
                                                                >
                                                                    {option?.TransshipmentName}
                                                                </MenuItem>
                                                            );
                                                        }
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div style={{ display: "flex", marginTop: 10 }}>
                                            <TextField
                                                name="third_vissel"
                                                label="Vessel 3RD"
                                                variant="outlined"
                                                placeholder="Vessel 3RD"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                style={{ width: "50%", marginRight: 5 }}
                                                InputLabelProps={{ shrink: true }}
                                                value={values.third_vissel}
                                            />
                                            {/* {errors.email && touched.email && errors.email} */}
                                            <FormControl sx={{ width: "50%" }}>
                                                <InputLabel>TRANSHIPMENT</InputLabel>
                                                <Select
                                                    name="third_vissel_transshipment"
                                                    label="TRANSHIPMENT"
                                                    value={values.third_vissel_transshipment}
                                                    InputLabelProps={{ shrink: true }}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    endAdornment={
                                                        values.third_vissel_transshipment && (
                                                          <InputAdornment position="end" sx={{marginRight:'30px'}}>
                                                            <IconButton
                                                              onClick={() =>
                                                                setFieldValue(
                                                                  "third_vissel_transshipment",
                                                                  ""
                                                                )
                                                              }
                                                              edge="end"
                                                            >
                                                              <ClearIcon />
                                                            </IconButton>
                                                          </InputAdornment>
                                                        )
                                                      }
                                                >
                                                    <MenuItem value="" disabled>
                                                        <em>เลือก TRANSSHIPMENT </em>
                                                    </MenuItem>
                                                    {transshipmentData.map(
                                                        (option, index) => {
                                                            return (
                                                                <MenuItem
                                                                    key={index}
                                                                    value={option?.TransshipmentId}
                                                                >
                                                                    {option?.TransshipmentName}
                                                                </MenuItem>
                                                            );
                                                        }
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div style={{ display: "flex", marginTop: 10 }}>
                                            <FormControl
                                                style={{ width: "50%", marginRight: 5 }}
                                            >
                                                <InputLabel>INCO TERMS</InputLabel>
                                                <Select
                                                    name="inco_terms"
                                                    label="INCO TERMS"
                                                    value={values.inco_terms}
                                                    InputLabelProps={{ shrink: true }}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                // disabled={values.freight_terms ? true : false}
                                                >
                                                    <MenuItem value="" disabled>
                                                        <em>เลือก INCO TERMS </em>
                                                    </MenuItem>
                                                    {incotermData.map((option, index) => {
                                                        return (
                                                            <MenuItem
                                                                key={index}
                                                                value={option?.IncotermsId}
                                                            >
                                                                {option?.IncotermName}
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Select>
                                            </FormControl>

                                            <FormControl sx={{ width: "50%" }}>
                                                <InputLabel>FREIGHT TERMS</InputLabel>
                                                <Select
                                                    name="freight_terms"
                                                    label="FREIGHT TERMS"
                                                    value={values.freight_terms}
                                                    InputLabelProps={{ shrink: true }}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                // disabled={values.inco_terms ? true : false}
                                                >
                                                    <MenuItem value="" disabled>
                                                        <em>เลือก FREIGHT TERMS </em>
                                                    </MenuItem>
                                                    {termsData.map((option, index) => {
                                                        return (
                                                            <MenuItem
                                                                key={index}
                                                                value={option?.FreightTermsId}
                                                            >
                                                                {option?.FreightTermsName}
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Grid>
                                <div style={{ display: "flex", marginTop: 10 }}>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        style={{
                                            color: "#80c340",
                                            borderColor: "#80c340",
                                            marginRight: "10px",
                                        }}
                                        onClick={history.goBack}
                                    >
                                        back
                                    </Button>
                                    <Button
                                        // type="submit"
                                        variant="contained"
                                        style={{
                                            background: "#80c340",
                                            borderColor: "#80c340",
                                            marginRight: "10px",
                                        }}
                                        onClick={() => setDiremark(true)}

                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting && <CircularProgress size={22} />}
                                        {!isSubmitting && "SAVE"}
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        style={{
                                            background: "#fff",
                                            borderColor: "#C8C8C8",
                                        }}
                                        onClick={async () => {
                                            setLoading(true)
                                            await api.get(`api/report/saleorder/download/pdf?SaleorderId=${id}`, {
                                                responseType: "blob",
                                                timeout: 30000
                                            })
                                                .then((blobFile) => {
                                                    const blobFileRes = new File([blobFile?.data], "test.pdf", {
                                                        type: mime.getType(".pdf"),

                                                    });

                                                    // window.open(
                                                    //   URL.createObjectURL(blobFileRes, "test.csv"),
                                                    //   "_blank"
                                                    // );
                                                    saveAs(blobFileRes, "Reportsaleorder.pdf");
                                                    setLoading(false)
                                                });

                                        }}

                                    >
                                        {loading ? <CircularProgress size={22} /> : <Typography sx={{ color: "#8E8C8C" }}>Print</Typography>}


                                    </Button>

                                    <Button
                                        variant="outlined"
                                        style={{ color: "#84BD5A", borderColor: "#84BD5A", marginLeft: "5px", width: "350px" }}

                                        onClick={async () => {
                                            setLoadingBD(true)
                                            await api.get(`api/report/booking-details-received/download/pdf?SaleorderId=${id}`, {
                                                responseType: "blob",
                                                timeout: 30000
                                            })
                                                .then((blobFile) => {
                                                    const blobFileRes = new File([blobFile?.data], "test.pdf", {
                                                        type: mime.getType(".pdf"),

                                                    });

                                                    // window.open(
                                                    //   URL.createObjectURL(blobFileRes, "test.csv"),
                                                    //   "_blank"
                                                    // );
                                                    saveAs(blobFileRes, "Report-booking-details-received.pdf");
                                                    setLoadingBD(false)
                                                });

                                        }}

                                    >
                                        {loadingBD ? <CircularProgress size={22} /> : <Typography sx={{ color: "#8E8C8C" }}>Print-booking-details-received</Typography>}


                                    </Button>
                                </div>
                                <Dialog fullWidth="sm" open={diremark}>
                                    <DialogTitle>Remark</DialogTitle>
                                    <DialogContent>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    autoFocus
                                                    name="RemarkLog"
                                                    label="Remark"
                                                    fullWidth
                                                    style={{marginTop:'5px'}}

                                                    color="success"
                                                    variant="outlined"
                                                    onChange={(r) => setremarkLog(r.target.value)}
                                                /></Grid>
                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <InputLabel>Remark Option</InputLabel>
                                                    <Select
                                                        name="RemarkType"
                                                        label="Remark Type"
                                                        value={remarkType}
                                                        InputLabelProps={{ shrink: true }}
                                                        onChange={(e) => setremarkType(e.target.value)}
                                                        MenuProps={{
                                                            style: {
                                                                maxHeight: 400,
                                                            },
                                                        }}
                                                    // disabled={values.inco_terms ? true : false}
                                                    >

                                                        {[
                                                            'Quotation Number',
                                                            'Customer reference detail',
                                                            'Volume',
                                                            'Booking Information',
                                                            'Free time',
                                                            'Intended Vessel',

                                                        ].map((option, index) => {
                                                            return (
                                                                <MenuItem
                                                                    key={index}
                                                                    value={option}
                                                                >
                                                                    {option}
                                                                </MenuItem>
                                                            );
                                                        })}
                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                        </Grid>


                                        <DialogActions
                                            sx={{
                                                marginTop: "24px",
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <form onSubmit={() => setDiremark(false)}>

                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    style={{
                                                        color: "#80c340",
                                                        borderColor: "#80c340",
                                                        marginRight: "10px",
                                                    }}
                                                    onClick={handleCloseremark}
                                                >
                                                    Cancel
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    type="submit"
                                                    style={{
                                                        background: remarklog ? "#80c340" : 'gray',
                                                        borderColor: "#80c340",
                                                        marginRight: "10px",
                                                        color: "#FFF",
                                                    }}
                                                    disabled={!remarklog ? true : false}
                                                >
                                                    Submit
                                                </Button>
                                            </form>
                                        </DialogActions>
                                    </DialogContent>
                                </Dialog>
                            </form>)}
                    </Formik> : 'loading...'}

            </LocalizationProvider>
        </div >
    );
}
